import { UPLOAD_CSV_CUSTOM_WATCHLIST } from '../types/uploadCsvCustomWatchlistTypes';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  uploadCsvCustomWatchlist,
  uploadCsvCustomWatchlistPending,
  uploadCsvCustomWatchlistFulfilled,
  uploadCsvCustomWatchlistRejected,
} = createAsyncActions(UPLOAD_CSV_CUSTOM_WATCHLIST, 'uploadCsvCustomWatchlist');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/uploadCsvCustomWatchlistActions.js